/*
 * @Author: wangshengqiang
 * @Date: 2021-12-23 16:52:35
 * @LastEditTime: 2022-02-21 15:22:44
 * @LastEditors: wangshengqiang
 * @Description: 签名组件
 */
import React, { useState } from 'react';
import { Button, Toast, Loading, Icon } from 'zarm';
import { uploadBase64File } from '@/services';
import imageSignBtn from '@/assets/images/signBtn.png';
import SignPanel from './SignPanel'; // import deleteBtn from '@/assets/images/deleteBtn.png';

export default (({
  value = '',
  onChange,
  getSignatureUrl,
  placeholder = '在此签名'
}) => {
  const [base64Url, setBase64Url] = useState('');
  const [isShowSignPanel, setIsShowSignPanel] = useState(false);
  const isShowPreviewImg = base64Url || value;

  const handleCancel = () => {
    setIsShowSignPanel(false);
  };

  const handleConfirm = async fileBase64 => {
    setBase64Url(fileBase64);
    getSignatureUrl && getSignatureUrl(fileBase64);
    const formData = new FormData();
    formData.append('fileStr', fileBase64);
    Loading.show();
    const res = await uploadBase64File(formData);
    const {
      message,
      success,
      result
    } = res;
    Loading.hide();
    const {
      url
    } = result || {};

    if (success && url) {
      setIsShowSignPanel(false);
      onChange(url);
      return;
    }

    return Toast.show(message || '服务异常');
  };

  const handleDelete = () => {
    onChange('');
    setBase64Url('');
  };

  const handleSign = () => {
    if (isShowPreviewImg) {
      return;
    }

    setIsShowSignPanel(true);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "sign-panel-contanier"
  }, /*#__PURE__*/React.createElement("div", {
    onClick: handleSign,
    className: "signBtn"
  }, isShowPreviewImg && /*#__PURE__*/React.createElement("span", {
    className: "delete-icon",
    onClick: handleDelete
  }), !isShowPreviewImg && /*#__PURE__*/React.createElement("img", {
    src: imageSignBtn,
    alt: "",
    style: {
      width: '21px',
      height: '21px'
    }
  }), isShowPreviewImg && /*#__PURE__*/React.createElement("img", {
    src: isShowPreviewImg,
    style: {
      width: '55px'
    },
    alt: "\u7B7E\u540D\u56FE"
  })), isShowSignPanel && /*#__PURE__*/React.createElement(SignPanel, {
    placeholder: placeholder,
    onCancel: handleCancel,
    onConfirm: handleConfirm
  }));
});